import { render } from "./LacosteBottomNavigation.vue?vue&type=template&id=0d5de7c0&scoped=true"
import script from "./LacosteBottomNavigation.vue?vue&type=script&lang=js"
export * from "./LacosteBottomNavigation.vue?vue&type=script&lang=js"

import "./LacosteBottomNavigation.vue?vue&type=style&index=0&id=0d5de7c0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d5de7c0"]])

export default __exports__